import { Component, Inject } from '@angular/core';

import { ProductConfig } from 'app/product-designer-config';
import { AdditionalInfoItemConfig
       } from 'collage-designer/collage-designer-config';
import { ProductService } from 'core/product/product.service';
import { AdditionalInfoItemInterface
       } from './additional-info-item-interface';

@Component({
    selector: 'smart-sorted',
    templateUrl: './smart-sorted.component.html',
    styleUrls: ['./smart-sorted.component.scss'],
    standalone: false
})
export class SmartSortedComponent implements AdditionalInfoItemInterface
{
  private static readonly CATALOG_PRODUCT_ID: RegExp =
      /^smart-sorted-.*puzzle.*-1000$/;

  public removeComponent: () => void;
  public SMASOConfig: ProductConfig|undefined;

  constructor (
      @Inject(ProductService) private productService: ProductService)
  { }

  public async initComponent(
      additionalInfoItem: AdditionalInfoItemConfig,
      rootDocument: Document): Promise<void>
  {
    const smasoProductId = this.productService
      .getProducts()
      .filter(pc => pc.inStock)
      .map(pc => pc.id)
      .find(id => SmartSortedComponent.CATALOG_PRODUCT_ID.test(id));

    this.SMASOConfig = await this.productService.getProductConfigById(
      smasoProductId);
  }

  public async changeProduct(): Promise<void>
  {
    await this.productService.setCurrentProduct(this.SMASOConfig.id);
  }

  public async isApplyable(): Promise<boolean>
  {
    if (SmartSortedComponent.CATALOG_PRODUCT_ID.test(
      this.productService.getCurrentProduct().id))
    {
      return false;
    }

    return this.productService
      .getProducts()
      .filter(pc => pc.inStock)
      .map(pc => pc.id)
      .some(id => SmartSortedComponent.CATALOG_PRODUCT_ID.test(id));
  }
}
